var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.7692C4.26708 14.7692 1.23077 11.7329 1.23077 8C1.23077 4.26708 4.26708 1.23077 8 1.23077C11.7329 1.23077 14.7692 4.26708 14.7692 8C14.7692 11.7329 11.7329 14.7692 8 14.7692ZM8 0C3.58154 0 0 3.58154 0 8C0 12.4185 3.58154 16 8 16C12.4185 16 16 12.4185 16 8C16 3.58154 12.4185 0 8 0ZM11.6923 7.38462H8.61539V3.07692C8.61539 2.73723 8.33969 2.46154 8 2.46154C7.66031 2.46154 7.38462 2.73723 7.38462 3.07692V8C7.38462 8.33969 7.66031 8.61539 8 8.61539H11.6923C12.032 8.61539 12.3077 8.33969 12.3077 8C12.3077 7.66031 12.032 7.38462 11.6923 7.38462Z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.d6a17fb01e5165c68fad02cfaca04c23.svg";
export { ForwardRef as ReactComponent };